"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _uaParserJs = require("ua-parser-js");

var _window;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var state = {
  agentParser: new _uaParserJs.UAParser(),
  config: {
    breakpoint: [3840, 2560, 1920, 1600, 1440, 1280, 960, 728, 600, 320]
  },
  storage: ((_window = window) === null || _window === void 0 ? void 0 : _window.localStorage) || {
    setItem: function setItem() {},
    getItem: function getItem() {}
  }
};

var setStorage = function setStorage(storageRef) {
  return state.storage = storageRef;
};

var getStorage = function getStorage() {
  return state.storage;
};

var setStorageValue = function setStorageValue(key, value) {
  getStorage().setItem(key, value);
  return value;
};

var getStorageValue = function getStorageValue(key) {
  return getStorage().getItem(key);
};

var getUAParser = function getUAParser() {
  return state.agentParser;
};

var setAgentParserDefaults = function setAgentParserDefaults() {
  var _window2, _window2$navigator;

  return getUAParser().setUA((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$navigator = _window2.navigator) === null || _window2$navigator === void 0 ? void 0 : _window2$navigator.userAgent);
};

var getAgentParserResults = function getAgentParserResults() {
  return getUAParser().getResult();
};

var getDevice = function getDevice() {
  return getUAParser().getDevice() || {};
};

var getDeviceType = function getDeviceType() {
  return Object.values(getUAParser().getDevice()).join(' ').trim() || 'webBrowser';
};

var getDeviceModel = function getDeviceModel() {
  var _getAgentParserResult, _getAgentParserResult2, _getAgentParserResult3, _getAgentParserResult4;

  return "".concat((_getAgentParserResult = getAgentParserResults()) === null || _getAgentParserResult === void 0 ? void 0 : (_getAgentParserResult2 = _getAgentParserResult.browser) === null || _getAgentParserResult2 === void 0 ? void 0 : _getAgentParserResult2.name, " ").concat((_getAgentParserResult3 = getAgentParserResults()) === null || _getAgentParserResult3 === void 0 ? void 0 : (_getAgentParserResult4 = _getAgentParserResult3.browser) === null || _getAgentParserResult4 === void 0 ? void 0 : _getAgentParserResult4.version);
};

var getDeviceOperatingSystem = function getDeviceOperatingSystem() {
  var _getAgentParserResult5, _getAgentParserResult6, _getAgentParserResult7, _getAgentParserResult8;

  return "".concat((_getAgentParserResult5 = getAgentParserResults()) === null || _getAgentParserResult5 === void 0 ? void 0 : (_getAgentParserResult6 = _getAgentParserResult5.os) === null || _getAgentParserResult6 === void 0 ? void 0 : _getAgentParserResult6.name, " ").concat((_getAgentParserResult7 = getAgentParserResults()) === null || _getAgentParserResult7 === void 0 ? void 0 : (_getAgentParserResult8 = _getAgentParserResult7.os) === null || _getAgentParserResult8 === void 0 ? void 0 : _getAgentParserResult8.version);
};

var getQueryParam = function getQueryParam(key) {
  var _window3, _window3$location;

  return new URLSearchParams((_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$location = _window3.location) === null || _window3$location === void 0 ? void 0 : _window3$location.search).get(key);
};

var getAppReferrer = function getAppReferrer() {
  var _document, _window4, _window4$location;

  return getQueryParam('referrer') || ((_document = document) === null || _document === void 0 ? void 0 : _document.referrer) || ((_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$location = _window4.location) === null || _window4$location === void 0 ? void 0 : _window4$location.href) || '';
};

var getEnvironmentByUrl = function getEnvironmentByUrl() {
  var _window5, _window5$location;

  var host = (((_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$location = _window5.location) === null || _window5$location === void 0 ? void 0 : _window5$location.host) || '').split('.')[0];
  if (host.includes('localhost')) return 'local';
  if (host.includes('engnew')) return 'staging';
  if (host.includes('engprod')) return 'staging';
  if (host.includes('dev-')) return 'staging';
  if (host.includes('dev2-')) return 'staging';
  if (host.includes('mock-')) return 'staging';
  if (host.includes('qa-')) return 'staging';
  if (host.includes('-qa')) return 'staging';
  if (host.includes('stage-')) return 'staging';
  if (host.includes('development.')) return 'staging';
  if (host.includes('staging.')) return 'staging';
  if (host.includes('ci1-.')) return 'staging';
  return 'prod';
};

var getCampaignId = function getCampaignId() {
  try {
    var _window6, _window6$location;

    var urlParams = new URLSearchParams((_window6 = window) === null || _window6 === void 0 ? void 0 : (_window6$location = _window6.location) === null || _window6$location === void 0 ? void 0 : _window6$location.search);
    return urlParams.get('cid') || urlParams.get('cmp');
  } catch (err) {
    console.log('Err', err);
  }
};

var getReferrerAppVisitId = function getReferrerAppVisitId() {
  try {
    var _window7, _window7$location;

    var urlParams = new URLSearchParams((_window7 = window) === null || _window7 === void 0 ? void 0 : (_window7$location = _window7.location) === null || _window7$location === void 0 ? void 0 : _window7$location.search);
    if (urlParams.get('visitId')) return urlParams.get('visitId');
    if (urlParams.get('exVisitID')) return urlParams.get('exVisitID');
  } catch (err) {
    console.log('Err', err);
  }
};

var getScreenResolution = function getScreenResolution() {
  return getCurrentBrowserWidth() + 'x' + getCurrentBrowserHeight();
};

var getCurrentBrowserHeight = function getCurrentBrowserHeight() {
  var _window8;

  return (_window8 = window) === null || _window8 === void 0 ? void 0 : _window8.innerHeight;
};

var getCurrentBrowserWidth = function getCurrentBrowserWidth() {
  var _window9;

  return (_window9 = window) === null || _window9 === void 0 ? void 0 : _window9.innerWidth;
};

var getCurrentBreakpoint = function getCurrentBreakpoint() {
  var _state$config;

  var width = getCurrentBrowserWidth();
  var breakpoints = (state === null || state === void 0 ? void 0 : (_state$config = state.config) === null || _state$config === void 0 ? void 0 : _state$config.breakpoint) || {};
  return breakpoints.find(function (value) {
    return value < width;
  });
};

var getFormFactor = function getFormFactor() {
  var _getDevice;

  return ((_getDevice = getDevice()) === null || _getDevice === void 0 ? void 0 : _getDevice.type) || 'pc';
}; // eslint-disable-next-line


var generatedUUIDV4 = function generatedUUIDV4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (x) {
    var t = 16 * Math.random() | 0;
    return ('x' === x ? t : 3 & t | 8).toString(16);
  });
};

var getDeviceUUIDV4 = function getDeviceUUIDV4() {
  var deviceIdKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'deviceUUID';
  return getStorageValue(deviceIdKey) ? getStorageValue(deviceIdKey) : setStorageValue(deviceIdKey, generatedUUIDV4());
};

var getUUIDV4 = function getUUIDV4() {
  var deviceIdKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'deviceUUID';
  return getDeviceUUIDV4(deviceIdKey);
};

var getCurrentLibState = function getCurrentLibState(window) {
  return JSON.parse(getStorageValue('library-state') || '{}');
};

var getVisitId = function getVisitId() {
  var _getCurrentLibState, _getCurrentLibState$m, _getCurrentLibState$m2;

  return ((_getCurrentLibState = getCurrentLibState(window)) === null || _getCurrentLibState === void 0 ? void 0 : (_getCurrentLibState$m = _getCurrentLibState.model) === null || _getCurrentLibState$m === void 0 ? void 0 : (_getCurrentLibState$m2 = _getCurrentLibState$m.visit) === null || _getCurrentLibState$m2 === void 0 ? void 0 : _getCurrentLibState$m2.visitId) || '';
};

var fetchDefaultData = function fetchDefaultData(collector) {
  return _objectSpread({
    appRefLink: getAppReferrer(),
    appEnvName: getEnvironmentByUrl(),
    deviceFormFactor: getFormFactor(),
    deviceModel: getDeviceModel(),
    deviceOperatingSystem: getDeviceOperatingSystem(),
    deviceUuid: getUUIDV4(),
    deviceType: getDeviceType(),
    uiResponsiveBreakpoint: getCurrentBreakpoint(),
    campaignId: getCampaignId()
  }, collector);
};

var _default = {
  setStorage: setStorage,
  getUAParser: getUAParser,
  setAgentParserDefaults: setAgentParserDefaults,
  getAgentParserResults: getAgentParserResults,
  getDevice: getDevice,
  getDeviceType: getDeviceType,
  getDeviceModel: getDeviceModel,
  getDeviceOperatingSystem: getDeviceOperatingSystem,
  getQueryParam: getQueryParam,
  getAppReferrer: getAppReferrer,
  getEnvironmentByUrl: getEnvironmentByUrl,
  getCurrentBrowserWidth: getCurrentBrowserWidth,
  getCurrentBreakpoint: getCurrentBreakpoint,
  getFormFactor: getFormFactor,
  getUUIDV4: getUUIDV4,
  generatedUUIDV4: generatedUUIDV4,
  getDeviceUUIDV4: getDeviceUUIDV4,
  getCurrentLibState: getCurrentLibState,
  getVisitId: getVisitId,
  fetchDefaultData: fetchDefaultData,
  getCampaignId: getCampaignId,
  getReferrerAppVisitId: getReferrerAppVisitId
};
exports["default"] = _default;